module.exports = __webpack_public_path__ + "img/check.01581037.png";